import { makeImmutable, Money } from "../../core";
/**
 * A group of items packed into containers.
 */
export class Packing {
    constructor(params) {
        this.containers = params.containers;
        makeImmutable(this);
    }
    static empty() {
        return new Packing({ containers: [] });
    }
    get price() {
        return Money.total(this.containers.map((container) => container.price));
    }
    addContainer(container) {
        this.containers.push(container);
    }
    pack(item) {
        let lastRemainder = item;
        for (const container of this.containers) {
            const result = container.pack(lastRemainder);
            if (result.type === "remained") {
                lastRemainder = result.remainder;
            }
            else {
                return result;
            }
        }
        return { type: "remained", remainder: lastRemainder };
    }
}
